import type { ReactNode } from 'react';

import PhotoLibraryIcon from '@mui/icons-material/FilterTwoTone';
import ViewCompactIcon from '@mui/icons-material/ViewCompactTwoTone';
import PalleteIcon from '@mui/icons-material/ColorLensTwoTone';

export interface SideBarMenuItem {
  link?: string;
  icon?: ReactNode;
  badge?: string;
  badgeTooltip?: string;
  items?: SideBarMenuItem[];
  name: string;
  isDisabled?: boolean;
}

const menuItems: SideBarMenuItem[] = [
  {
    name: 'Template Library',
    icon: ViewCompactIcon,
    link: '/templates'
  },
  {
    name: 'My Graphics',
    icon: PhotoLibraryIcon,
    link: '/graphics'
  },
  {
    name: 'Brand Kit',
    icon: PalleteIcon,
    link: '/brandkit'
  }
];

export default menuItems;
